import React, { useEffect, useState } from 'react';
import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Spinner,
  Button,
} from 'reactstrap';

import BreadCrumb from '../../../Components/Common/BreadCrumb';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

//redux
import TableContainer from '../../../Components/Common/TableContainer';
import { withTranslation } from 'react-i18next';
import { Can } from '../../../helpers/casl';
import Search from '../../../Components/Common/Search';
import RangeDatePicker from '../../../Components/Common/RangeDatePicker';
import moment from 'moment';
import useQsParams from '../../../Components/Hooks/QueryString';
import EmptyList from '../../../Components/Common/EmptyList';

const TableAccountTransactionManagement = ({
  props,
  columns,
  isLoading,
  accountTransactions,
  meta,
  page,
  accountTransactionType,
  accountTransactionIdentifierType,
  setPage,
  setShowCreateModal,
}) => {
  const { qs, setSearchParams, setSearchParamsAsObject, setQs } =
    useQsParams();
  const [createdAt, setCreatedAt] = useState([]);
  const animatedComponents = makeAnimated();

  const multiSelectStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '320px',
      width: 'auto',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#1a2a3e',
      fontSize: '14px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#cccccc',
      svg: {
        width: '20px',
        height: '20px',
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      width: '18px',
      transition: '.2s ease-in',
      ':hover': {
        color: '#999999',
      },
    }),
  };

  const _parseCreatedAt = () => {
    const hasCreatedAt = qs.get('createdAt');
    let dateRange = [];

    if (hasCreatedAt) {
      const from = hasCreatedAt?.split(',')?.[0];
      const to = hasCreatedAt?.split(',')?.[1];

      dateRange = [
        moment.unix(from).format('D/M/YY'),
        moment.unix(to || from).format('D/M/YY'),
      ];
    }

    setCreatedAt(dateRange);
  };

  useEffect(() => {
    _parseCreatedAt();
  }, [qs.get('createdAt')]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={props.t('account-transaction-management.heading')} pageTitle={props.t('account-transaction-management.extra')} />
        <Row>
          <Col lg={12}>
            <Card id="leadsList">
              <CardHeader className="border-0">
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-12 g-2 g-lg-3">
                  <Col xl={2}>
                    <Search
                      placeholder={props.t('account-transaction-management.table.identifier')}
                      value={qs?.get('identifier')?.replace(/%/g, '')}
                      onSubmit={({ id }) => {
                        const value = _.trim(id);
                        setSearchParamsAsObject({
                          identifier: id ? `%${value}%` : '',
                          page: 1,
                        });
                      }}
                    />
                  </Col>

                  <Col xl={'auto'}>
                    <Select
                      name="identifierType"
                      id="identifierType"
                      isClearable
                      isSearchable
                      components={animatedComponents}
                      isMulti={false}
                      placeholder={props.t('account-transaction-management.table.identifier-type')}
                      onChange={(selectedOption) => {
                        setSearchParamsAsObject({
                          identifier_type: selectedOption?.value || null,
                          page: 1,
                        });
                      }}
                      value={accountTransactionIdentifierType.filter((x) => {
                        const actionInUrl = qs.get('identifier_type')?.split(',');
                        return actionInUrl?.includes(x.value);
                      })}
                      options={accountTransactionIdentifierType}
                      styles={multiSelectStyles}
                    />
                  </Col>

                  <Col xl={'auto'}>
                    <Select
                      name="type"
                      id="type"
                      isClearable
                      isSearchable
                      components={animatedComponents}
                      isMulti={false}

                      placeholder={props.t('account-transaction-management.table.type')}
                      onChange={(selectedOption) => {
                        setSearchParamsAsObject({
                          type: selectedOption?.value || null,
                          page: 1,
                        });
                      }}
                      value={accountTransactionType.filter((x) => {
                        const actionInUrl = qs.get('type')?.split(',');
                        return actionInUrl?.includes(x.value);
                      })}
                      options={accountTransactionType}
                      styles={multiSelectStyles}
                    />
                  </Col>

                  <Col xl={2}>
                    <RangeDatePicker
                      onClear={() => setSearchParams('created_at', '')}
                      placeholder={props.t('account-transaction-management.table.created_at')}
                      value={createdAt}
                      onChange={(v) => {
                        if (v[0] && v[1]) {
                          const d1 = moment(v[0]).unix();
                          const d2 = moment(v[1]).unix();
                          const value = !d2 ? d1 : `${d1},${d2}`;
                          setSearchParams('created_at', value);
                        }
                      }}
                    />
                  </Col>

                  {isLoading ? (
                    <Col xl="auto">
                      <Spinner color="secondary" className="m-0" />
                    </Col>
                  ) : null}

                  <Col sm={12} md="auto" className="ms-auto">
                    <div className="hstack gap-2">
                      <Button
                        color="success"
                        onClick={() => setShowCreateModal(true)}
                        className="add-btn"
                        id="create-btn"
                      >
                        <i className="ri-add-line align-bottom me-1"></i>
                        {props.t('account-transaction-management.create-button')}
                      </Button>
                    </div>
                  </Col>
                  <Col sm={12} md="auto" className="ms-auto">
                    <div className="hstack gap-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setQs('showFilter', true)}
                        disabled={isLoading}
                      >
                        <i className="ri-filter-3-line align-bottom me-1"></i>{' '}
                        {props.t('advanced-filters')}
                      </button>
                    </div>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <Can I="read" a="account_transaction">
                  <div>
                    {!accountTransactions?.length && qs.toString() ? (
                      <div className="mt-3">
                        <EmptyList
                          heading={props.t('search-empty-heading')}
                          body={props.t('table-content-empty-results')}
                        />
                      </div>
                    ) : (
                      <TableContainer
                        isLoading={isLoading}
                        columns={columns}
                        data={accountTransactions || []}
                        activePage={page}
                        pageSize={meta?.take || 10}
                        totalPages={meta?.pages || 0}
                        count={meta?.total || 0}
                        setPage={setPage}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-0"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                      />
                    )}
                  </div>
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withTranslation()(TableAccountTransactionManagement);
